import { lazy } from "react";

const SmcnCertListBase = lazy(() => import("app/pages/rp/smcnCert/smcnList/SmcnCertListBase"));
const SmcnCertFormBase = lazy(() => import("app/pages/rp/smcnCert/smcnForm/SmcnCertFormBase"));
const SmcnCertDetailBase = lazy(() => import("app/pages/rp/smcnCert/smcnDetail/SmcnCertDetailBase"));
const Portfolio = lazy(() => import("../pages/rp/pfl/Portfolio"))
const UseConfirmationList = lazy(() => import("../pages/rp/useConfirmation/UseConfirmationList"))
const UseConfirmationInsert = lazy(() => import("../pages/rp/useConfirmation/UseConfirmationInsert"))
const UseConfirmationDetail = lazy(() => import("../pages/rp/useConfirmation/UseConfirmationDetail"))
const ProcureMain = lazy(() => import("app/pages/rp/procure/ProcureMain"));
const Re100Status = lazy(() => import("app/pages/rp/status/Re100Status"));
const ProcureDetail = lazy(() => import("app/pages/rp/procure/ProcureDetail"));
const RlibrList = lazy(() => import("../pages/rp/rlibr/RlibrList"))
const RlibrDetail = lazy(() => import("../pages/rp/rlibr/RlibrDetailPage"))
const RlibrInsert = lazy(() => import("../pages/rp/rlibr/RlibrInsert"))
const ImplWayAnalysis = lazy(() => import("../pages/rp/implWayAnalysis/ImplWayAnalysis"))
const RdmpGoalSetting = lazy(() => import("../pages/rp/rdmp/RdmpGoalSetting"))
const GoalManage = lazy(() => import("../pages/rp/rdmp/GoalManage"))
const ScenarioView = lazy(() => import("../pages/rp/scnro/ScenarioView"))

export const rpRouter: any = [
  {path: "/rp/status", element: <Re100Status/>},
  {path: "/rp/portfolio/:menuActiveTab?", element: <Portfolio/>,},

  // RE100 플래너 > 인증관리 > 이행수단 실적 등록
  { path: "/rp/smcnCert", element: <SmcnCertListBase /> },
  { path: "/rp/smcnCert/form", element: <SmcnCertFormBase /> },
  { path: "/rp/smcnCert/detail", element: <SmcnCertDetailBase /> },

  {path: "/rp/useConfirmationList/:ucfmCd?", element: <UseConfirmationList/>},
  {path: "/rp/useConfirmationInsert", element: <UseConfirmationInsert/>},
  {path: "/rp/useConfirmationDetail/:emksFuflMeansCd/:smcnCertId", element: <UseConfirmationDetail/>},
  {path: "/rp/rlibr/:menuActiveTab?", element: <RlibrList/>},
  {path: "/rp/rlibrDetail/:menuActiveTab?/:rlibrId", element: <RlibrDetail/>},
  {path: "/rp/rlibrInsert/:menuActiveTab?", element: <RlibrInsert/>},
  {path: "/rp/impleWayAnalysis/:menuActiveTab?", element: <ImplWayAnalysis/>},
  // 새 구성. 예전 화면은 rp/rdmpGoalSetting/old 로 남긴다
  {path: "rp/rdmpGoalSetting", element: <GoalManage/>},
  {path: "rp/rdmpGoalSetting/old", element: <RdmpGoalSetting/>},
  // 새 구성. 예전 화면은 rp/ScenarioDetail/old/:scnroId 로 남긴다
  {path: "rp/ScenarioDetail/:scnroId", element: <ScenarioView/>},
  {path: "/rp/procure", element: <ProcureMain/>},
  {path: "/rp/procure/:means", element: <ProcureDetail/>},
];